module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-normal-small.06431dce.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-normal-small.png
// module id = 2642
// module chunks = 11